const _2017 = [
    {
        alias: "canadais",
        image: "https://i.cbc.ca/1.4501466.1516805255!/fileImage/httpImage/canada-is-banner.png",
        description:
            "An online series showcasing the many facets of Canadian identity. Leading figures in each field explore how their area relates to Canadian culture and capture a part of what it means to be Canadian.",
    },
    {
        alias: "canadathestoryofus",
        image: "https://i.cbc.ca/1.4584750.1521574142!/fileImage/httpImage/canada-story-of-us.jpg",
        navigation: [
            {
                link: "/2017/canadathestoryofus/canada-the-story-of-us-1.4005217",
                title: "About",
                type: "internal",
            },
            {
                link: "/2017/canadathestoryofus/csou-episodes",
                title: "Episodes",
                type: "internal",
            },
            {
                link: "https://gem.cbc.ca",
                title: "Watch",
                type: "external",
            },
            {
                link: "/2017/canadathestoryofus/canada-the-story-of-us-faqs-1.4048136",
                title: "FAQs",
                type: "internal",
            },
        ],
    },
    {
        alias: "wearecanada",
        image: "https://i.cbc.ca/1.4584765.1521574346!/fileImage/httpImage/image.jpg_gen/derivatives/original_1180/we-are-canada-banner.jpg",
        navigation: [
            {
                link: "/2017/wearecanada/about-we-are-canada-1.4028018",
                title: "About",
                type: "internal",
            },
            {
                link: "https://gem.cbc.ca/we-are-canada",
                title: "Watch",
                type: "external",
            },
        ],
    },
    {
        alias: "we-are-the-best",
        image: "https://i.cbc.ca/1.4584771.1521574419!/fileImage/httpImage/we-are-the-best-thumbnail.png",
        navigation: [
            {
                link: "/2017/we-are-the-best/about-we-are-the-best-1.3907805",
                title: "About",
                type: "internal",
            },
        ],
    },
    {
        alias: "becoming-canadian",
        image: "https://i.cbc.ca/1.4584786.1521574744!/fileImage/httpImage/image.jpg_gen/derivatives/original_1180/becoming-canadian-banner.jpg",
        navigation: [
            {
                link: "/2017/becoming-canadian/about-becoming-canadian-1.3919482",
                title: "About",
                type: "internal",
            },
        ],
    },
    {
        alias: "truenorthcalling",
        image: "https://i.cbc.ca/1.4584797.1521574885!/fileImage/httpImage/image.jpg_gen/derivatives/original_1180/true-north-calling.jpg",
        navigation: [
            {
                link: "/2017/truenorthcalling/about-true-north-calling-1.3949724",
                title: "About",
                type: "internal",
            },
            {
                link: "https://gem.cbc.ca/true-north-calling",
                title: "Watch",
                type: "external",
            },
        ],
    },
];

export default _2017;
